/**
 * @fileoverview Racine du portail citoyen GNPC.
 *
 * Monte le routeur et les providers visuels. Les données affichées dans cette
 * première tranche sont mockées pour travailler le design sans backend.
 */

import { RouterProvider } from 'react-router-dom';
import { Toaster, TooltipProvider } from '@gnpc/ui';
import { router } from './router.tsx';

export function App(): JSX.Element {
  return (
    <TooltipProvider>
      <RouterProvider router={router} />
      <Toaster richColors closeButton position="bottom-center" />
    </TooltipProvider>
  );
}
